import { Inject, Injectable } from '@angular/core';
import { Regione } from '@models/regione.model';
import { NgxCrudService } from '@sinapsys/ngx-crud';
import { Observable, map } from 'rxjs';
import { COMMON_APP_CONFIG } from '../tokens/common-config.token';

@Injectable({
  providedIn: 'root',
})
export class RegioniService extends NgxCrudService<Regione, number> {
  constructor(@Inject(COMMON_APP_CONFIG) private mainConfig: Required<{ api: { apiBaseUrl: string } }>) {
    super({ apiBaseUrl: '' });
    this._baseUrl += this.mainConfig.api.apiBaseUrl + 'gestione-articoli/regioni/';
  }

  getAutocomplete(sq: string): Observable<Regione[]> {
    return this.search({ $or: { nomeregione: { $like: sq } } }).pipe(
      map((c) => c.items.map((c) => new Regione(c)))
    );
  }
}
